type BrandProps = {
  compact?: boolean;
};

export function Brand({ compact = false }: BrandProps) {
  return (
    <a className={compact ? 'brand compact' : 'brand'} href="/" aria-label="Vibeco Studio 首页">
      <span className="brand-mark" aria-hidden="true" />
      <span className="brand-copy">
        <strong>Vibeco Studio</strong>
        {!compact ? <small>Design to Code</small> : null}
      </span>
    </a>
  );
}
